import { useDispatch } from 'react-redux';
import { addToast } from 'src/slices/toast';

const useToast = () => {
  const dispatch = useDispatch();

  // Check if the error is a cancellation from delete confirmation
  const isCancellationError = (params) => {
    if (!params || !params.error) return false;
    
    const error = params.error;
    return (
      error.message?.includes('Delete operation cancelled by user') || 
      error.isCancellation || 
      (error.response?.data?.message?.includes('Delete operation cancelled by user'))
    );
  };

  // params = { type, message, verb, name, error }
  const getToastByType = (type) => (params) => {
    // Skip showing error toasts for cancellation errors
    if (type === 'error' && isCancellationError(params)) {
      return null;
    }
    
    return dispatch(addToast({ ...params, type }));
  };

  const success = getToastByType('success');
  const error = getToastByType('error');
  const warning = getToastByType('warning');
  const info = getToastByType('info');
  const toast = getToastByType('none');

  toast.success = success;
  toast.error = error;
  toast.warning = warning;
  toast.info = info;

  return toast;
};

export default useToast;
